import req, {Opts} from 'shared/req';
import InternalServerError from './status-errors/internal-server-error';
import BadRequestError from './status-errors/bad-request-error';
import BasicLoginInvalidEmail from './special-errors/basic-login-invalid-email';
import BackendError from './backend-error';
import NotFoundError from './status-errors/not-found-error';

const errorClasses: (typeof BackendError)[] = [
  BadRequestError,
  NotFoundError,
  InternalServerError,
  BasicLoginInvalidEmail,
  // TODO: Add more error classes as needed
];

interface CaughtError {
  // TODO: better name
  // the shape of what comes out of a caught req error
  type: string;
  message: string;
}

/**
 *
 * @param error CaughtError
 * @param status an http code retrieved from the request metadata
 * @returns Error
 *
 * Prefer matching on error name (A specific level error), use status as backup for a mid-level error, and if neither is found something weird happened as an error caught here should at least always have a status, if not a type sent from the backend.
 */
const getErrorClass = (error: CaughtError, status: number) => {
  let ErrorClass = errorClasses.find((errorClass) => errorClass.name === error.type);
  if (!ErrorClass) {
    // use status as backup
    ErrorClass = errorClasses.find((errorClass) => (errorClass as $TSFixMe).status === status);
  }
  if (!ErrorClass) {
    // throw the original error if we can't find a matching class
    throw error;
  }
  return ErrorClass;
};

const transformSingleError = (error: {type: string; message: string}, status: number) => {
  const ErrorClass = getErrorClass(error, status);
  // @ts-expect-error: It thinks that an array of any | never cannot have stuff on it, since caught Errors have to be of type any | never
  return new ErrorClass(error.message);
};

const transformErrors = (errors: $TSFixMe, status: number) => {
  if (Array.isArray(errors)) {
    return errors.map((error) => transformSingleError(error, status));
  }
  return [transformSingleError(errors, status)];
};

const reqWithErrorResponseTransforming = async <Result, TransformedResponse = Result>(
  options: Opts<Result, TransformedResponse>
) => {
  try {
    return await req<Result, TransformedResponse>(options);
  } catch (errors: $TSFixMe) {
    const {status} = errors; // extract request metadata

    const transformed = transformErrors(errors, status);
    if (transformed.length > 0) {
      // I guess it always will be if we're in here but just in case
      throw transformed;
    } else {
      console.error('something weird happened');
      throw errors;
    }
  }
};

export default reqWithErrorResponseTransforming;
